/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import { AnyAction } from 'redux';
import { setLocationUrlAction } from './urlchangeevents.actions';
import { SET_LOCATION_URL } from './urlchangeevents.types';

const initialState: {
    url: string;
} = {
    url: '',
};

const urlChangeEventsReducer = (state = initialState, { type, payload } = <AnyAction>{}) => {
    switch (type) {
        case SET_LOCATION_URL:
            return {
                ...state,
                url: payload.url,
            };
        default:
            return state;
    }
};

export const setLocationUrl = (url: string) => (dispatch: Function) => {
    window.history.pushState('', '', url);
    dispatch(setLocationUrlAction(url));
};

export default urlChangeEventsReducer;
